import React from 'react';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { createRoot } from 'react-dom/client';
import store from './store';
import { Provider } from 'mobx-react';
import * as Sentry from '@sentry/react';
const isProduction = process.env.REACT_APP_MODE === 'production';
if(isProduction){
    Sentry.init({
        dsn: 'https://8ea6e5234822097243198a9969fda9c3@sentry.grtcloud.net/4',
        environment: process.env.REACT_APP_MODE,
        //开发或者本地设置false
        //注意：将其设置为 enabled: false 并不会阻止 Sentry 仪表的所有开销。要完全禁用 Sentry，需要根据环境有条件地调用 `Sentry.init`。
        enabled: isProduction,
        integrations: [
            Sentry.browserTracingIntegration({
                enableLongTask: false,
                // 匹配所有 *.grtcloud.net 域名接口
                tracePropagationTargets: [/\.grtcloud\.net/]
            }),
            Sentry.replayIntegration()
        ],
        tracesSampleRate: isProduction ? 0.2 : 1.0,
        replaysSessionSampleRate: isProduction ? 0.05 : 0.1,
        replaysOnErrorSampleRate: 1.0,
        ignoreErrors: [
            /^@sentry-internal/,
            'top.GLOBALS',
            /^Illegal invocation/,
            'ResizeObserver loop limit exceeded'
        ],
        denyUrls: [
            /^chrome:\/\//i,
            /^chrome-extension:\/\//i,
            /^moz-extension:\/\//i,
            /^safari-extension:\/\//i,
            /^safari-web-extension:\/\//i,
            /extensions\//i,
            /^file:\/\//i,
            /^resource:\/\//i,
            /^webpack-internal:/i,
            /^webpack:/i,
            /jsdelivr\.net/i,
            /unpkg\.com/i,
            /cdnjs\.cloudflare\.com/i
        ],
        beforeSend(event) {
            const frames = event.exception?.values?.[0]?.stacktrace?.frames || [];
            // 全部堆栈都来自node_modules，才过滤
            if (frames.length > 0 && frames.every(f => f.filename?.includes('node_modules'))) {
                return null;
            }
            return event;
        }
    });
}

// 1、从三方跳过来，存入local
// 2、直接打开如果没有，给默认值---直播
// 3、退出应该清除local
// 4、存入local主要是为了低代码平台中outRequest使用
if (window.name) {
    localStorage.setItem('BI', window.name);
}
const root = createRoot(document.getElementById('root'));

root.render(
    <Provider store={store}>
        <App />
    </Provider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
